import React from 'react';
import classNames from 'classnames';
import useDarkMode from '../../../hooks/useDarkMode';
import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>
							© 2025 TNSC Bank Ltd. This Tool is maintained and administered by TNSC
							Bank Ltd. All rights reserved.
						</span>
					</div>
					<div className='col-auto'>
						<a
							href='/'
							className={classNames(
								'text-decoration-none d-flex align-items-center gap-2',
								{
									'link-dark': !darkModeStatus,
									'link-light': darkModeStatus,
								},
							)}>
							<small className='fw-bold'>
								Tamil Nadu State Apex Co-operative Bank Ltd
							</small>
							<img
								src={require('../../../assets/logos/tnscLogo.jpg')}
								alt='Tamil Nadu State Apex Co-operative Bank Ltd.,'
								style={{ height: '30px', width: 'auto', objectFit: 'contain' }}
							/>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
